import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { getStorage } from 'src/app/utils/helper/storage';
import { CURRENT_USER } from 'src/app/utils/items/storage-names';
import { DoctorService } from 'src/app/utils/services/doctor/doctor.service';

@Component({
  selector: 'app-doctor-autocomplete',
  templateUrl: './doctor-autocomplete.component.html',
  styleUrls: ['./doctor-autocomplete.component.scss']
})
export class DoctorAutocompleteComponent implements OnInit {

  @Input() doctorType: string = '';

  @Output() search: EventEmitter<any> = new EventEmitter<any>();

  @Output() clear: EventEmitter<any> = new EventEmitter<any>();

  @Output() select: EventEmitter<any> = new EventEmitter<any>();

  @Output() unselect: EventEmitter<any> = new EventEmitter<any>();
  
  results: any;
  selected: any;
  user: any;
  md_id: any;  


  constructor(
    private service: DoctorService
  ) { }

  ngOnInit(): void {
    this.user = getStorage(CURRENT_USER, true);
  }

  onSearch(event) {
    this.service.getDoctors({
      query: event?.query,
      includes: 'user',
      doctorType: this.doctorType
    })
    .subscribe((response: any) => {
      this.results = response?.data;
      this.search.emit(response);
    });
  }

  onClear(item) {
    this.selected = null; 
    this.clear.emit(item);
  }

  onUnselect(item) {
    this.unselect.emit(item);
  }

  onSelect(item) {
    if (!item) return; // Ensure item is not null
    console.log('Selected Doctor:', item); // Debugging log
    this.selected = item;
    this.md_id = item.md_id; // Store md_id
    this.select.emit(item); // Emit full doctor object
  }

}
